import usePrivateLink from "../../config/usePrivateLink";
import React, { useState, useEffect, useRef } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";

import {
  CreateMarketingStudent,
  DeleteMarketingStudent,
  MarketingStudentList,
} from "../../../api/MarketinService";

import {
  BlockFetch,
  DistrictFetch,
  StateFetch,
} from "../../../api/LocationService";

import Swal from "sweetalert2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getSessions } from "../../../api/SessionsService";
import {
  ToastMain,
  SweetAlertShow,
} from "../../master/Master";
import { courseList } from "../../../api/Courses";
import MarketingHeader from "./MarketingHeader";
import { setPrintContent } from "../../../PrintStore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const StudentCreateSource = () => {
  const hasAccess = usePrivateLink();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [allStates, setAllStates] = useState([]);
  const [allDistricts, setAllDistricts] = useState([]);
  const [allBlock, setAllBlock] = useState([]);

  const [session, setSession] = useState("");
  const [data, setData] = useState("");
  const [source, setSource] = useState([]);
  const [courses, setCourses] = useState([]);

  const [address, setAddress] = useState(false);
  const [permission, setPermission] = useState(false);

  const [selectedSession, setSelectedSession] = useState("");
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [area, setArea] = useState("");

  const [Selectedsource, setSelectedSource] = useState("");
  const [HostelId, setHostelId] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [sourceId, setSourceId] = useState("");

  const [file, setFile] = useState(null);
  const [responseMsg, setResponseMsg] = useState(null);

  const [sessions, setSessions] = useState([]);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const source_id = queryParams.get("id");
  const source_name = queryParams.get("name");

  const [student, setStudent] = useState([]);
  const [status, setStatus] = useState("");
  const [course_id, setCourseId] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [excelData, setExcelData] = useState([]);

  const [rowErrors, setRowErrors] = useState({});

  const [statuses, setStatuses] = useState([]);

  const [batch, setBatch] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [delay, setDelay] = useState(1000);

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

  const [startDate, setStartDate] = useState(
    queryParams.get("start_date") || ""
  );

  const [selectedBatchId, setSelectedBatchId] = useState("");

  const handleToggle = () => {
    setAddress((prev) => !prev);
  };

  const handlePermissionToggle = () => {
    setPermission((prev) => !prev);
  };

  const courseFetch = async () => {
    setLoading(true);

    try {
      const response = await courseList();

      if (response.data.status) {
        setCourses(response?.data?.data || []);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
  }, []);

  const createStudent = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      formData.append("session_id", selectedSession);

      const response = await CreateMarketingStudent(formData);

      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "created successfully!",
        }).then(() => {
          fetchStudent();
          e.target.reset();
        });
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }

        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.message ??
        error?.response?.data?.message ??
        error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getSession = async () => {
    try {
      const response = await getSessions();

      if (response.data.status) {
        const activeSession = response?.data?.data?.find(
          (s) => s?.status == "1"
        );

        setSelectedSession(activeSession?.id);
        setSession(response?.data);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    }
  };

  const getState = async () => {
    setLoading(true);

    try {
      const response = await StateFetch();

      if (response.data) {
        setAllStates(response?.data?.states);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getdistrict = async (state) => {
    setLoading(true);

    try {
      const response = await DistrictFetch(state);

      if (response.data) {
        setAllDistricts(response?.data?.districts);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getblock = async (district) => {
    setLoading(true);

    try {
      const response = await BlockFetch(district);

      if (response?.data) {
        setAllBlock(response?.data?.blocks);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getState();
    getSession();
  }, []);

  const navigate = useNavigate();

  const fetchStudent = async () => {
    let addUrl = `&session=${selectedSession}&search=${search}&area=${area}&source_id=${source_id}&page=${page}`;

    setLoading(true);

    try {
      const response = await MarketingStudentList(addUrl);

      if (response.data.status) {
        setStudent(response?.data?.data);
      } else {
        setError("Failed to fetch courses.");

        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (source_id) {
      fetchStudent();
    }
  }, [
    selectedSession,
    search,
    source_id,
    area,
    page,
  ]);

  const deleteStudent = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await DeleteMarketingStudent(id);

          console.log(
            "student deleted",
            response.data
          );

          fetchStudent();

          ToastMain.fire({
            icon: "success",
            title: "delete successfully!",
          });
        } catch (error) {
          SweetAlertShow(
            "error",
            "Error",
            error?.response?.data?.message ??
            error?.message
          );
        }
      }
    });
  };

  const handlePrint = () => {
    const printTable = (
      <div className="table-responsive">
        <table className="table text-center align-middle table-sm">
          <caption className="caption-top text-center fw-bold fs-5 mb-2 text-nowrap">
            {source_name} Student List
          </caption>

          <thead className="table-primary">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Father's Name</th>
              <th>Address</th>
              <th>Education Level</th>
              <th>Note</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody className="text-capitalize">
            {student?.data?.length === 0 ? (
              <tr>
                <td
                  colSpan="8"
                  className="text-center"
                >
                  No Data Found
                </td>
              </tr>
            ) : (
              student?.data?.map((std, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>

                  <td>
                    {std.name || "N/A"}
                  </td>

                  <td>
                    {std.mobile || "N/A"}
                  </td>

                  <td>
                    {std.fathers_name || "N/A"}
                  </td>

                  <td>
                    {std.village || "N/A"}{" "}
                    {std?.district}{" "}
                    {std?.state}{" "}
                    {std?.pincode}
                  </td>

                  <td>
                    {std.edu_level || "N/A"}
                  </td>

                  <td>
                    {std.description || "N/A"}
                  </td>

                  <td>
                    {std.status === "1"
                      ? "Active"
                      : "Inactive"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <nav
          aria-label="Page navigation"
          className="mt-10"
        >
          <p>
            Showing {student?.from} to{" "}
            {student?.to} of{" "}
            {student?.total} entries
          </p>

          <ul className="pagination pagination-sm">
            {student?.links?.map((btn, i) => (
              <li
                key={i}
                className={`page-item ${btn?.active ? "active" : ""
                  } ${btn?.url ? "" : "disabled"
                  }`}
              >
                <button
                  className="page-link waves-effect"
                  onClick={() => {
                    if (
                      student?.links?.length ===
                      i + 1
                    ) {
                      btn?.url &&
                        setPage(
                          student?.current_page + 1
                        );
                    } else if (i === 0) {
                      btn?.url &&
                        setPage(
                          student?.current_page - 1
                        );
                    } else {
                      setPage(btn.label);
                    }
                  }}
                >
                  {student?.links?.length ==
                    i + 1 ? (
                    <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                  ) : i == 0 ? (
                    <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                  ) : (
                    btn?.label
                  )}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div className="d-flex justify-content-between align-items-center"></div>
      </div>
    );

    setPrintContent(printTable);
    navigate("/print");
  };

  // =========================
  // EXCEL START
  // =========================

  const intervalRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    setSelectedFile(file);

    if (!file) {
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryStr = event.target.result;

      const workbook = XLSX.read(
        binaryStr,
        { type: "binary" }
      );

      const sheetName =
        workbook.SheetNames[0];

      const sheet =
        workbook.Sheets[sheetName];

      const rows =
        XLSX.utils.sheet_to_json(
          sheet,
          { raw: false }
        );

      setExcelData(rows);

      setStatuses(
        Array(rows.length).fill("pending")
      );

      setCurrentIndex(0);
    };

    reader.readAsBinaryString(file);
  };

  const updateStatus = (index, status) => {
    setStatuses((prev) => {
      const newStatuses = [...prev];

      newStatuses[index] = status;

      return newStatuses;
    });
  };

  const formatDate = (excelDate) => {
    if (!excelDate) return "";

    if (typeof excelDate === "string") {
      const parsed = new Date(excelDate);

      if (!isNaN(parsed)) {
        return parsed
          .toISOString()
          .split("T")[0];
      }

      return excelDate;
    }

    if (typeof excelDate === "number") {
      const date = new Date(
        (excelDate - 25569) *
        86400 *
        1000
      );

      if (!isNaN(date)) {
        return date
          .toISOString()
          .split("T")[0];
      }

      return "";
    }

    return "";
  };

  const uploadRow = async (index) => {
    const row = {
      ...excelData[index],
    };

    if (selectedSession) {
      row.session_id = selectedSession;
      row.source_id = source_id;
    }

    const formData = new FormData();

    Object.entries(row).forEach(
      ([key, val]) => {
        if (key === "admission_date") {
          formData.append(
            key,
            formatDate(val)
          );
        } else {
          formData.append(
            key,
            val ?? ""
          );
        }
      }
    );

    try {
      const res =
        await CreateMarketingStudent(
          formData
        );

      if (
        res.status === false &&
        res.errors
      ) {
        updateStatus(
          index,
          "failed"
        );

        setRowErrors((prev) => ({
          ...prev,
          [index]: res.errors,
        }));

        return;
      }

      updateStatus(
        index,
        "success"
      );
    } catch (error) {
      console.error(
        `Upload failed for row ${index}`,
        error
      );

      updateStatus(
        index,
        "failed"
      );

      if (
        error.response?.data?.errors
      ) {
        setRowErrors((prev) => ({
          ...prev,
          [index]:
            error.response.data.errors,
        }));
      }
    }
  };

  const handleUpload = async () => {
    if (!excelData.length) {
      return alert("No data");
    }

    const processRow = async (index) => {
      if (
        index >=
        excelData.length
      ) {
        setLoading(false);
        return;
      }

      if (
        statuses[index] ===
        "pending"
      ) {
        await uploadRow(index);

        await new Promise(
          (res) =>
            setTimeout(
              res,
              delay
            )
        );
      }

      if (
        statuses[index] ===
        "failed"
      ) {
        setCurrentIndex(index);
        return;
      }

      setCurrentIndex(
        index + 1
      );

      await processRow(
        index + 1
      );
    };

    processRow(
      currentIndex
    );
  };

  const handleNext = () => {
    setCurrentIndex(
      (prev) => prev + 1
    );

    handleUpload();
  };

  const handleRepair = (index) => {
    updateStatus(
      index,
      "pending"
    );

    setRowErrors((prev) => {
      const updated = {
        ...prev,
      };

      delete updated[index];

      return updated;
    });

    setCurrentIndex(index);

    handleUpload();
  };

  const countStatus = (type) =>
    statuses.filter(
      (status) =>
        status === type
    ).length;

  const handleDownloadFormat = () => {
    const data = [
      [
        "registration",
        "name",
        "father_name",
        "mother_name",
        "mobile",
        "secondary_phone",
        "gender",
        "email",
        "category",
        "aadhar",
        "dob",
        "nic_id",
        "apaar_id",
        "rte",
        "village",
        "state",
        "district",
        "pincode",
        "education",
        "school_name",
        "referred_by",
        "batch_id",
        "reg_fee",
        "total_fee",
        "batch_discount",
        "discount_remark",
        "emiCheckbox",
        "total_emi",
        "emi_amount_1",
        "emi_date_1",
        "emi_amount_2",
        "emi_date_2",
        "emi_amount_3",
        "emi_date_3",
        "emi_amount_4",
        "emi_date_4",
        "bus_route_id",
        "bus_id",
        "bus_fees",
        "bus_final_fees",
        "bus_discount",
        "image",
      ],

      [
        "1019",
        "DAYA",
        "MASURI",
        "HASURRI",
        "9306487930",
        "1234567890",
        "Male",
        "monuyadav@gmail.com",
        "OBC",
        "123443211234",
        "2025-08-01",
        "3456738jhfkdls",
        "gfhjklsfdaj",
        "NON-RTE",
        "Chomu",
        "Chomu",
        "Haryana",
        "Bhiwani",
        "000409",
        "BA Pass",
        "Shree Bala Ji",
        "Manoj Yadav",
        "28",
        "2000",
        "13000",
        "2000",
        "By Monu",
        "1",
        "4",
        "3250",
        "2025-08-25",
        "3250",
        "2025-09-25",
        "3250",
        "2025-10-25",
        "3250",
        "2025-11-25",
        "8",
        "6",
        "1200.00",
        "1000.00",
        "200",
        "student.jpg",
      ],
    ];

    const worksheet =
      XLSX.utils.aoa_to_sheet(
        data
      );

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Students"
    );

    const excelBuffer =
      XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

    const blob = new Blob(
      [excelBuffer],
      {
        type: "application/octet-stream",
      }
    );

    saveAs(
      blob,
      "students_template.xlsx"
    );
  };

  // =========================
  // RETURN
  // =========================

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{
            zIndex: 9999,
          }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">

          <Header />

          <div className="layout-page">

            <Nav />

            <div className="content-wrapper">

              <div className="container-fluid mt-2">

                {/* FIXED LAYOUT */}
                <div>

                  <MarketingHeader
                    data={"Marketing Portal"}
                  />

                  {/* MAIN CARD */}
                  <div className="card mt-2 w-100">

                    <div className="py-4 px-3 mb-4">

                      <div className="d-flex justify-content-between align-items-center mb-4">

                        <h3 className="text-primary fw-bold text-capitalize">
                          {source_name} Students
                        </h3>

                        <div>

                          {hasAccess(
                            "/marketing/add_student"
                          ) && (
                              <button
                                onClick={() => {
                                  navigate(
                                    `/marketing/add_student?sourse_name=${source_name}&sourse_id=${source_id}`
                                  );
                                }}
                                className="btn btn-info btn-sm d-inline-flex align-items-center overflow-hidden transition-button"
                              >
                                <span className="icon">
                                  +
                                </span>

                                <span className="text ms-2">
                                  Add New Student
                                </span>
                              </button>
                            )}

                          <button
                            onClick={() =>
                              navigate(-1)
                            }
                            className="btn btn-outline-primary mb-3 mt-3 ms-2"
                          >
                            <i className="bi bi-arrow-left-circle me-1"></i>
                            Back
                          </button>

                          {hasAccess(
                            "/marketing/add_student/source/print"
                          ) && (
                              <button
                                className="btn btn-primary ms-2"
                                onClick={
                                  handlePrint
                                }
                              >
                                Print
                              </button>
                            )}

                          {hasAccess(
                            "/marketing/students/import"
                          ) && (
                              <button
                                className="btn btn-info btn-sm ms-2"
                                data-bs-toggle="modal"
                                data-bs-target="#excelUploadModal"
                              >
                                <i className="bi bi-cloud-arrow-up ri-20px"></i>
                              </button>
                            )}

                        </div>

                      </div>

                      {/* FILTERS */}

                      <div>

                        <div className="row">

                          <div className="col-md-3 form-floating form-floating-outline">

                            <select
                              className="form-select"
                              name="session"
                              value={
                                selectedSession
                              }
                              onChange={(e) =>
                                setSelectedSession(
                                  e.target.value
                                )
                              }
                            >
                              {session?.data?.map(
                                (sess) => (
                                  <option
                                    key={
                                      sess.id
                                    }
                                    value={
                                      sess.id
                                    }
                                  >
                                    {sess.session} :{" "}
                                    {sess.status ===
                                      "1"
                                      ? "Active"
                                      : "Inactive"}
                                  </option>
                                )
                              )}
                            </select>

                            <label>
                              Select Session
                            </label>

                          </div>

                          <div className="col-md-3 form-floating form-floating-outline">

                            <input
                              type="text"
                              className="form-control"
                              name="search"
                              placeholder="student name"
                              value={
                                search
                              }
                              onChange={(e) =>
                                setSearch(
                                  e.target.value
                                )
                              }
                            />

                            <label>
                              Student name
                            </label>

                          </div>

                          <div className="col-md-3 form-floating form-floating-outline">

                            <input
                              type="text"
                              className="form-control"
                              name="area"
                              placeholder="search address"
                              value={
                                area
                              }
                              onChange={(e) =>
                                setArea(
                                  e.target.value
                                )
                              }
                            />

                            <label>
                              Address
                            </label>

                          </div>

                        </div>

                      </div>

                      {/* STUDENT TABLE */}

                      <div className="table-responsive mt-4">

                        <table className="table text-center align-middle table-sm">

                          <thead className="table-primary">

                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>Mobile</th>
                              <th>
                                Father's Name
                              </th>
                              <th>
                                Address
                              </th>
                              <th>
                                Education Level
                              </th>
                              <th>
                                Note
                              </th>
                              <th>
                                Status
                              </th>
                              <th>
                                Action
                              </th>
                            </tr>

                          </thead>

                          <tbody className="text-capitalize">

                            {student?.data
                              ?.length ===
                              0 ? (

                              <tr>
                                <td
                                  colSpan="9"
                                  className="text-center"
                                >
                                  No Data Found
                                </td>
                              </tr>

                            ) : (

                              student?.data?.map(
                                (
                                  std,
                                  index
                                ) => (

                                  <tr
                                    key={
                                      index
                                    }
                                  >

                                    <td>
                                      {index +
                                        1}
                                    </td>

                                    <td>
                                      {std.name ||
                                        "N/A"}
                                    </td>

                                    <td>
                                      {std.mobile ||
                                        "N/A"}
                                    </td>

                                    <td>
                                      {std.fathers_name ||
                                        "N/A"}
                                    </td>

                                    <td>
                                      {std.village ||
                                        "N/A"}{" "}
                                      {
                                        std?.district
                                      }{" "}
                                      {
                                        std?.state
                                      }{" "}
                                      {
                                        std?.pincode
                                      }
                                    </td>

                                    <td>
                                      {std.edu_level ||
                                        "N/A"}
                                    </td>

                                    <td>
                                      {std.description ||
                                        "N/A"}
                                    </td>

                                    <td>
                                      {std.status ===
                                        "1"
                                        ? "Active"
                                        : "Inactive"}
                                    </td>

                                    <td>

                                      <div className="d-flex gap-1">

                                        {hasAccess(
                                          "/marketing/update_student"
                                        ) && (
                                            <Link
                                              className="btn btn-outline-primary btn-sm"
                                              to="/marketing/update_student"
                                              state={{
                                                id: std,
                                              }}
                                            >
                                              <i className="bi bi-pencil-square text-primary"></i>
                                            </Link>
                                          )}

                                        {hasAccess(
                                          "/marketing/student/delete"
                                        ) && (
                                            <button
                                              className="btn btn-sm btn-outline-danger text-danger"
                                              onClick={() =>
                                                deleteStudent(
                                                  std.id
                                                )
                                              }
                                            >
                                              <i className="bi bi-trash-fill text-danger"></i>
                                            </button>
                                          )}

                                      </div>

                                    </td>

                                  </tr>

                                )
                              )

                            )}

                          </tbody>

                        </table>

                        {/* PAGINATION */}

                        <nav
                          aria-label="Page navigation"
                          className="mt-10"
                        >

                          <p>
                            Showing{" "}
                            {
                              student?.from
                            }{" "}
                            to{" "}
                            {
                              student?.to
                            }{" "}
                            of{" "}
                            {
                              student?.total
                            }{" "}
                            entries
                          </p>

                          <ul className="pagination pagination-sm">

                            {student?.links?.map(
                              (
                                btn,
                                i
                              ) => (

                                <li
                                  key={i}
                                  className={`page-item ${btn?.active
                                      ? "active"
                                      : ""
                                    } ${btn?.url
                                      ? ""
                                      : "disabled"
                                    }`}
                                >

                                  <button
                                    className="page-link waves-effect"
                                    onClick={() => {

                                      if (
                                        student?.links
                                          ?.length ===
                                        i + 1
                                      ) {

                                        btn?.url &&
                                          setPage(
                                            student?.current_page +
                                            1
                                          );

                                      } else if (
                                        i ===
                                        0
                                      ) {

                                        btn?.url &&
                                          setPage(
                                            student?.current_page -
                                            1
                                          );

                                      } else {

                                        setPage(
                                          btn.label
                                        );

                                      }

                                    }}
                                  >

                                    {student?.links
                                      ?.length ==
                                      i + 1 ? (

                                      <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />

                                    ) : i ==
                                      0 ? (

                                      <i className="icon-base ri ri-skip-back-mini-line icon-20px" />

                                    ) : (

                                      btn?.label

                                    )}

                                  </button>

                                </li>

                              )
                            )}

                          </ul>

                        </nav>

                      </div>

                    </div>

                  </div>

                </div>

                <Footer />

                <div className="content-backdrop fade"></div>

              </div>

            </div>

          </div>

          <div className="layout-overlay layout-menu-toggle"></div>

          <div className="drag-target"></div>

        </div>
      </div>

      {/* =========================
          ADD STUDENT MODAL
      ========================= */}

      <div
        className="modal fade"
        id="addstudent"
        tabIndex="-1"
        aria-labelledby="excelUploadModalLabel"
        aria-hidden="true"
      >

        <div className="modal-dialog modal-dialog-scrollable modal-xl">

          <div className="modal-content shadow-lg rounded-3">

            <div className="modal-header bg-label-primary p-3 text-white d-flex justify-content-between align-items-center rounded-top-3">

              <h5
                className="modal-title fw-bold"
                id="excelUploadModalLabel"
              >
                Add Student in{" "}
                {source_name}
              </h5>

              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

            </div>

            <div className="modal-body">

              <form
                onSubmit={
                  createStudent
                }
              >

                <input
                  type="hidden"
                  name="source_id"
                  value={
                    source_id
                  }
                  readOnly
                />

                <div className="row">

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <input
                      className="form-control text-capitalize input-capitalize"
                      type="text"
                      name="name"
                      placeholder="Student Name"
                    />

                    <label>
                      Student Name
                    </label>

                    <span className="text-danger">
                      {error?.name ??
                        ""}
                    </span>

                  </div>

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <input
                      className="form-control text-capitalize input-uppercase"
                      type="text"
                      name="fathers_name"
                      placeholder="Father Name"
                    />

                    <label>
                      Father Name
                    </label>

                    <span className="text-danger">
                      {error?.fathers_name ??
                        ""}
                    </span>

                  </div>

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <input
                      className="form-control text-capitalize"
                      type="text"
                      name="mobile"
                      placeholder="Mobile No"
                      minLength={10}
                      maxLength={10}
                    />

                    <label>
                      Mobile No
                    </label>

                    <span className="text-danger">
                      {error?.mobile ??
                        ""}
                    </span>

                  </div>

                  <div className="form-floating col-md-6 form-floating-outline mb-4">

                    <select
                      className="form-select text-capitalize"
                      id="course_id"
                      name="course_id"
                      required
                    >

                      <option value="">
                        Select Course
                      </option>

                      {courses.map(
                        (
                          course
                        ) => (

                          <option
                            key={
                              course.id
                            }
                            value={
                              course.id
                            }
                          >
                            {
                              course.title
                            }
                          </option>

                        )
                      )}

                    </select>

                    <label htmlFor="course">
                      Select Course
                    </label>

                    <span className="text-danger">
                      {error?.course_id ??
                        ""}
                    </span>

                  </div>

                </div>

                <div className="row">

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <select
                      className="form-select text-capitalize"
                      name="edu_level"
                    >

                      <option
                        value=""
                        disabled
                        selected
                      >
                        Select Education
                      </option>

                      <option value="9th">
                        9th
                      </option>

                      <option value="10th">
                        10th
                      </option>

                      <option value="11th">
                        11th
                      </option>

                      <option value="12th">
                        12th
                      </option>

                    </select>

                    <label>
                      Last Education
                    </label>

                    <span className="text-danger">
                      {error?.edu_level ??
                        ""}
                    </span>

                  </div>

                </div>

                <hr />

                <div className="row">

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <input
                      className="form-control text-capitalize"
                      type="text"
                      name="alternate_no"
                      placeholder="Alternate No"
                      minLength={10}
                      maxLength={10}
                    />

                    <label>
                      Alternate No
                    </label>

                    <span className="text-danger">
                      {error?.alternate_no ??
                        ""}
                    </span>

                  </div>

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <input
                      className="form-control text-capitalize input-uppercase"
                      type="text"
                      name="village"
                      placeholder="Village"
                    />

                    <label>
                      Village
                    </label>

                    <span className="text-danger">
                      {error?.village ??
                        ""}
                    </span>

                  </div>

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <select
                      className="form-select text-capitalize"
                      name="state"
                      onChange={(e) =>
                        getdistrict(
                          e.target.value
                        )
                      }
                    >

                      <option value="">
                        Select State
                      </option>

                      {allStates?.map(
                        (
                          state
                        ) => (

                          <option
                            key={
                              state.id
                            }
                            value={
                              state.name
                            }
                          >
                            {
                              state.name
                            }
                          </option>

                        )
                      )}

                    </select>

                    <label>
                      State
                    </label>

                    <span className="text-danger">
                      {error?.state ??
                        ""}
                    </span>

                  </div>

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <select
                      className="form-select text-capitalize"
                      name="district"
                      onChange={(e) =>
                        getblock(
                          e.target.value
                        )
                      }
                    >

                      <option value="">
                        Select District
                      </option>

                      {allDistricts?.map(
                        (
                          district
                        ) => (

                          <option
                            key={
                              district.id
                            }
                            value={
                              district.name
                            }
                          >
                            {
                              district.name
                            }
                          </option>

                        )
                      )}

                    </select>

                    <label>
                      District
                    </label>

                    <span className="text-danger">
                      {error?.district ??
                        ""}
                    </span>

                  </div>

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <input
                      className="form-control text-capitalize"
                      type="text"
                      name="pincode"
                      placeholder="Pincode"
                    />

                    <label>
                      Pincode
                    </label>

                    <span className="text-danger">
                      {error?.pincode ??
                        ""}
                    </span>

                  </div>

                  <div className="col-md-6 mb-4 form-floating form-floating-outline">

                    <textarea
                      className="form-control text-capitalize input-uppercase"
                      name="description"
                      placeholder="Note"
                      rows="3"
                      style={{
                        height: "100px",
                      }}
                    ></textarea>

                    <label>
                      Note
                    </label>

                    <span className="text-danger">
                      {error?.description ??
                        ""}
                    </span>

                  </div>

                </div>

                <div className="d-flex justify-content-end">

                  <button
                    type="submit"
                    className="btn btn-primary px-5"
                    disabled={
                      loading
                    }
                  >

                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Submit"
                    )}

                    {loading
                      ? " Submitting..."
                      : ""}

                  </button>

                </div>

              </form>

            </div>

          </div>

        </div>

      </div>

      {/* =========================
          EXCEL UPLOAD MODAL
      ========================= */}

      <div
        className="modal fade"
        id="excelUploadModal"
        tabIndex="-1"
        aria-labelledby="excelUploadModalLabel"
        aria-hidden="true"
      >

        <div className="modal-dialog modal-dialog-scrollable modal-xl">

          <div className="modal-content shadow-lg rounded-3">

            <div className="modal-header bg-label-primary p-3 text-white d-flex justify-content-between align-items-center rounded-top-3">

              <h5
                className="modal-title fw-bold"
                id="excelUploadModalLabel"
              >
                🧾 Excel Data Preview
              </h5>

              <h5 className="mb-3 text-primary">
                📤 Upload Excel
              </h5>

            </div>

            <div className="modal-body">

              <div className="container-fluid">

                <div className="d-flex flex-wrap align-items-center mb-3 gap-2">

                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={
                      handleFileChange
                    }
                    className="form-control w-50"
                  />

                  <select
                    className="form-select"
                    name="session"
                    value={
                      selectedSession
                    }
                    onChange={(e) =>
                      setSelectedSession(
                        e.target.value
                      )
                    }
                  >

                    {session?.data?.map(
                      (sess) => (

                        <option
                          key={
                            sess.id
                          }
                          value={
                            sess.id
                          }
                        >
                          {sess.session} :{" "}
                          {
                            sess.status ===
                              "1"
                              ? "Active"
                              : "Inactive"
                          }
                        </option>

                      )
                    )}

                  </select>

                  <select
                    value={delay}
                    onChange={(e) =>
                      setDelay(
                        Number(
                          e.target.value
                        )
                      )
                    }
                    className="form-select w-auto"
                  >

                    {[...Array(15)].map(
                      (_, i) => (

                        <option
                          key={i}
                          value={
                            (i + 1) *
                            1000
                          }
                        >
                          Delay:{" "}
                          {i + 1}s
                        </option>

                      )
                    )}

                  </select>

                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={
                      handleDownloadFormat
                    }
                  >
                    Dummy Data
                  </button>

                </div>

                <div className="alert alert-light border mb-3 p-2 small">

                  ✅ Success:{" "}
                  {countStatus(
                    "success"
                  )}

                  {" | "}

                  ❌ Failed:{" "}
                  {countStatus(
                    "failed"
                  )}

                  {" | "}

                  ⏳ Pending:{" "}
                  {countStatus(
                    "pending"
                  )}

                </div>

                {excelData.length >
                  0 && (

                    <div
                      className="table-responsive"
                      style={{
                        maxHeight:
                          "400px",
                        overflowY:
                          "auto",
                      }}
                    >

                      <table className="table table-bordered table-hover align-middle">

                        <thead
                          className="table-primary sticky-top"
                          style={{
                            zIndex: 5,
                          }}
                        >

                          <tr>

                            <th
                              style={{
                                width:
                                  "50px",
                              }}
                            >
                              #
                            </th>

                            {Object.keys(
                              excelData[0]
                            ).map(
                              (
                                key,
                                idx
                              ) => (

                                <th
                                  key={
                                    idx
                                  }
                                >
                                  {key}
                                </th>

                              )
                            )}

                            <th>
                              Status
                            </th>

                            <th>
                              Action
                            </th>

                          </tr>

                        </thead>

                        <tbody>

                          {excelData.map(
                            (
                              row,
                              idx
                            ) => (

                              <tr
                                key={
                                  idx
                                }
                              >

                                <td className="fw-bold">
                                  {idx +
                                    1}
                                </td>

                                {Object.keys(
                                  row
                                ).map(
                                  (
                                    key,
                                    i
                                  ) => (

                                    <td
                                      key={
                                        i
                                      }
                                    >

                                      {statuses[
                                        idx
                                      ] ===
                                        "failed" ? (

                                        <div>

                                          <input
                                            type="text"
                                            className={`form-control form-control-sm ${rowErrors?.[
                                                idx
                                              ]?.[
                                                key
                                              ]
                                                ? "is-invalid"
                                                : ""
                                              }`}
                                            value={
                                              row[
                                              key
                                              ]
                                            }
                                            onChange={(
                                              e
                                            ) => {

                                              const newData =
                                                [
                                                  ...excelData,
                                                ];

                                              newData[
                                                idx
                                              ][
                                                key
                                              ] =
                                                e.target.value;

                                              setExcelData(
                                                newData
                                              );

                                            }}
                                          />

                                          {rowErrors?.[
                                            idx
                                          ]?.[
                                            key
                                          ] && (

                                              <div className="invalid-feedback">
                                                {
                                                  rowErrors[
                                                  idx
                                                  ][
                                                  key
                                                  ][0]
                                                }
                                              </div>

                                            )}

                                        </div>

                                      ) : (

                                        row[
                                        key
                                        ]

                                      )}

                                    </td>

                                  )
                                )}

                                <td>

                                  {statuses[
                                    idx
                                  ] ===
                                    "success" &&
                                    "✅"}

                                  {statuses[
                                    idx
                                  ] ===
                                    "failed" &&
                                    "❌"}

                                  {statuses[
                                    idx
                                  ] ===
                                    "pending" &&
                                    "⏳"}

                                </td>

                                <td>

                                  {statuses[
                                    idx
                                  ] ===
                                    "failed" && (

                                      <button
                                        className="btn btn-sm btn-outline-info"
                                        onClick={() =>
                                          handleRepair(
                                            idx
                                          )
                                        }
                                      >
                                        Retry
                                      </button>

                                    )}

                                </td>

                              </tr>

                            )
                          )}

                        </tbody>

                      </table>

                    </div>

                  )}

              </div>

            </div>

            <div className="modal-footer d-flex justify-content-between">

              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
              >
                ❌ Cancel
              </button>

              <div className="d-flex gap-2">

                <button
                  type="button"
                  className="btn btn-label-primary"
                  onClick={
                    handleUpload
                  }
                  disabled={
                    loading
                  }
                >
                  {loading
                    ? "Uploading..."
                    : "🚀 Start Upload"}
                </button>

                <button
                  className="btn btn-warning"
                  onClick={() => {

                    const firstFailed =
                      statuses.findIndex(
                        (s) =>
                          s ===
                          "failed"
                      );

                    if (
                      firstFailed !==
                      -1
                    ) {
                      setCurrentIndex(
                        firstFailed
                      );

                      handleUpload();
                    }

                  }}
                >
                  🔁 Retry Failed
                </button>

              </div>

            </div>

          </div>

        </div>

      </div>

    </>
  );
};

export default StudentCreateSource;